import { Check } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { images } from "@/data/site";

const points = [
  "IHK-zertifizierter betrieblicher Mobilitätsmanager",
  "Persönliche Einweisung – ganz ohne Zeitdruck",
  "Schnelle, unkomplizierte Kommunikation",
  "Region Frankfurt / Rödermark-Urbach",
];

export const About = () => {
  useReveal();
  return (
    <section id="ueber-uns" data-testid="about-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="reveal relative">
          <div className="rounded-3xl overflow-hidden border border-white/10">
            <img
              src={images.about}
              alt="Tesla Model 3"
              className="w-full h-[380px] md:h-[520px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 md:right-6 bg-white text-black rounded-2xl px-6 py-5 shadow-xl">
            <p className="font-heading text-3xl font-extrabold leading-none">100%</p>
            <p className="text-xs mt-1 text-black/60">5-Sterne-Bewertungen</p>
          </div>
        </div>

        <div className="reveal">
          <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
            Über uns
          </p>
          <h2 className="font-heading font-bold text-white tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight">
            Elektromobilität, ehrlich vermittelt.
          </h2>
          <div className="mt-6 space-y-5 text-white/65 leading-relaxed">
            <p>
              Tesla-Verleih-Frankfurt ist Ihr persönlicher Ansprechpartner für
              Elektromobilität im Rhein-Main-Gebiet. Statt anonymem
              Flottengeschäft erwartet Sie eine individuelle Betreuung – von der
              ersten Anfrage bis zur Rückgabe.
            </p>
            <p>
              Wer vor einer Kaufentscheidung steht oder Elektromobilität einfach
              einmal in Ruhe erleben möchte, ist hier genau richtig. Sie fahren
              einen gepflegten Tesla und bekommen zusätzlich fundiertes Wissen
              eines IHK-zertifizierten Mobilitätsmanagers an die Hand.
            </p>
          </div>

          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-white/80">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-white flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-black" strokeWidth={3} />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
